import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import { EXPORT_TYPES, MODULES, TABLE_FILTER_KEYS } from '../../../../../common/constants';
import { isSalesUser } from '../../../../../common/utils';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import ResetFilterButton from '../../../../../components/ResetFilterButton';
import AllReturnTable from '../components/AllReturnTable';
import AllTabs from '../components/AllTabs';
import { REQUEST_RETURN_ORDER_EXPORT_ADMIN } from '../graphql/Mutations';

const AllReturn = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    state: { currentUser },
  } = useContext(AppContext);

  const [requestReturnOrderExportAdmin] = useMutation(
    REQUEST_RETURN_ORDER_EXPORT_ADMIN,
    {
      onError: () => { },
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestReturnOrderExportAdmin({
      variables: {
        data: {
          type: EXPORT_TYPES?.RETURN_ORDER,
        },
        filter: {
          search: exportFilter?.search,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          status:
            exportFilter?.status?.length > 0 ? exportFilter?.status : undefined,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.ALL}</div>
      </Portal>
      {!isSalesUser(currentUser) && (
        <>
          <Portal portalId="header-right-content">
            <Button
              className="common-button ml-16"
              size="middle"
              icon={<ExportOutlined />}
              onClick={() => setIsModalOpen(true)}
              loading={isExportLoading}
            >
              Export
            </Button>
          </Portal>
          <Portal portalId="header-right-content-phones">
            <Button
              className="common-button ml-16"
              size="middle"
              icon={<ExportOutlined />}
              onClick={() => setIsModalOpen(true)}
              loading={isExportLoading}
            >
              Export
            </Button>
          </Portal>{' '}
        </>
      )}
      <ResetFilterButton tableKey={TABLE_FILTER_KEYS.ALL_RETURN} />
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <AllTabs>
        <div className="tab-table">
          <AllReturnTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
          />
        </div>
      </AllTabs>
    </>
  );
};

export default AllReturn;
